import React from 'react';
import PropTypes from 'prop-types';
import { Container, QuestionLabel } from '../styles';
import { Content } from './style';
import Heatmap from '../../heatmap';

const ParticipantFirstClickQuestion = (props) => {
  const {
    label, imageUrl, index, firstClickCoordinatesAnswer, questionId,
  } = props;

  const data = [{
    firstClickCoordinates: {
      x: firstClickCoordinatesAnswer.x,
      y: firstClickCoordinatesAnswer.y,
    },
  }];

  return (
    <Container key={index}>
      <QuestionLabel>{`Question ${index + 1}: ${label} (First Click Test)`}</QuestionLabel>
      <Content>
        <Heatmap
          imageSrc={imageUrl}
          data={data}
          id={questionId}
        />
      </Content>
    </Container>
  );
};

ParticipantFirstClickQuestion.propTypes = {
  label: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  firstClickCoordinatesAnswer: PropTypes.objectOf({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }),
  questionId: PropTypes.string.isRequired,
};

ParticipantFirstClickQuestion.defaultProps = {
  firstClickCoordinatesAnswer: {
    x: 0,
    y: 0,
  },
};

export default ParticipantFirstClickQuestion;
